import { RefObject, useEffect, useRef, useState } from 'react';
import { GameName, GameNameWrapper } from './widget-styles';

const GameNameInfiniteScrolling = ({
	gameName,
	containerRef
}: {
	gameName: string;
	containerRef: RefObject<HTMLDivElement>;
}) => {
	const textRef = useRef<HTMLParagraphElement>(null);
	const [showScrollTextComponent, setShowScrollTextComponent] = useState<boolean | undefined>(undefined);

	useEffect(() => {
		if (showScrollTextComponent === undefined) {
			setShowScrollTextComponent(
				(textRef.current?.getBoundingClientRect().width || 0) >
					(containerRef.current?.getBoundingClientRect().width || 0)
			);
		}
	}, [containerRef, showScrollTextComponent]);

	return (
		<GameNameWrapper>
			<GameName ref={textRef} showScrollTextComponent={showScrollTextComponent}>
				{gameName} {showScrollTextComponent && gameName}
			</GameName>
		</GameNameWrapper>
	);
};

export default GameNameInfiniteScrolling;
